import qs from 'query-string'
import { CookieSetOptions } from 'universal-cookie'

import { buildContextForWebsitePageView } from '@syconium/weeping-figs'

import { MagnoliaRequest } from './MagnoliaRequest'

export const staticContentRequestRegex = new RegExp(
  /^(\/[a-zA-Z]{2}-[a-zA-Z]{2})?\/(static|api\/static|vendor-redirect|_next|robots|sitemap|favicon.ico).*$/
)

export const dynamicContentRequestRegex = new RegExp(
  /^(?!(\/[a-zA-Z]{2}-[a-zA-Z]{2})?\/(static|api\/static|vendor-redirect|_next|robots|sitemap|favicon.ico)).*$/
)

export const sharedContentRequestRegex = new RegExp(
  /^(\/[a-zA-Z]{2}-[a-zA-Z]{2})?((\/products\/.*)|(\/kits\/.*)|(\/collections\/.*)|(\/search.*))$/
)

const trailingForwardSlashRegex = new RegExp(/\/$/)
export const optionalLocaleURLRegex = new RegExp(/^(\/[a-zA-Z]{2}-[a-zA-Z]{2})?(\/.*)?$/)

export const getParsedExpressRequestInfo = (req: MagnoliaRequest) => {
  const unsanitizedPath = req.baseUrl + req.path
  const sanitizedPath =
    unsanitizedPath === '' || unsanitizedPath === '/'
      ? '/'
      : unsanitizedPath.replace(trailingForwardSlashRegex, '').replaceAll('//', '/')

  const shopLocalizationContext =
    req.shopLocalizationContext ??
    buildContextForWebsitePageView({
      headers: req.headers,
      cookies: req.universalCookies,
      urlPath: req.originalUrl.split('?')[0] ?? req.originalUrl,
    })

  const pathSegmentMatches = sanitizedPath.match(optionalLocaleURLRegex)
  const pathWithoutLocalization = pathSegmentMatches?.[1]
    ? pathSegmentMatches?.[2] ?? '/'
    : sanitizedPath

  const queryString = qs.stringify(req.query)
  const urlWithoutLocalization = `${pathWithoutLocalization}${queryString ? '?' : ''}${queryString}`

  return {
    urlWithoutLocalization,
    pathWithoutLocalization,
    shopLocalizationContext,
  }
}

export const replaceCookieInCookiesHeader = ({
  key,
  value,
  header,
}: {
  key: string
  value: string | undefined
  header: string
}) => {
  let updatedHeader = header
  if (updatedHeader.includes(`${key}=`)) {
    const cookieEntryRegex = new RegExp(`(^|(\\; ))${key}=[^\\;]*`, 'g')
    const invalidPrefix = new RegExp(`^\\; `)
    updatedHeader = updatedHeader.replaceAll(cookieEntryRegex, '').trim()
    updatedHeader = updatedHeader.replace(invalidPrefix, '')
  }
  if (value) {
    updatedHeader = `${updatedHeader.length > 0 ? updatedHeader + '; ' : ''}${key}=${value}`
  }
  return updatedHeader
}

export const setCookieOnExpressRequest = ({
  req,
  key,
  value,
  options,
}: {
  req: MagnoliaRequest
  key: string
  value: string
  options: CookieSetOptions
}) => {
  req.headers.cookie = replaceCookieInCookiesHeader({
    key: key,
    value: value,
    header: req.headers.cookie ?? '',
  })
  req.universalCookies.set(key, value, options)
}

export const removeCookieOnExpressRequest = ({
  req,
  key,
}: {
  req: MagnoliaRequest
  key: string
}) => {
  req.headers.cookie = replaceCookieInCookiesHeader({
    key: key,
    value: undefined,
    header: req.headers.cookie ?? '',
  })
  req.universalCookies.remove(key)
}
